module.exports = __webpack_public_path__ + "assets/img/NVIDIA-bcbc12b9.png";